.matchupCard {
  width: 100%;
  background-color: var(--cxy-color-container-light);
  border-radius: var(--cxy-spacing-2);
  overflow: hidden;
  color: var(--cxy-color-content-default);
  font-family: var(--font-family-base);
  box-sizing: border-box;
}

.header {
  display: grid;
  grid-template-columns: minmax(250px, 3fr) repeat(3, minmax(auto, 1fr));
  grid-column-gap: var(--cxy-spacing-1);
  background-color: var(--cxy-color-container-subtle);
  align-items: center;
  padding: 0 var(--cxy-spacing-4);
}

.matchupCard:has(.soccerTeamRow) .header {
  grid-template-columns: minmax(320px, 3fr) repeat(3, minmax(90px, 1fr));
}

.eventInfo {
  font-size: var(--cxy-fontSize-s);
  font-weight: var(--cxy-fontWeight-semiBold);
  color: var(--cxy-color-content-default);
}

.marketGrid {
  display: grid;
  grid-template-columns: minmax(250px, 3fr) repeat(3, minmax(auto, 1fr));
  grid-column-gap: var(--cxy-spacing-1);
  grid-row-gap: var(--cxy-spacing-1);
  background-color: var(--cxy-color-container-light);
  width: 100%;
  padding: 0 var(--cxy-spacing-1) var(--cxy-spacing-4) var(--cxy-spacing-1);

  @media (min-width: 1025px) {
    padding: var(--cxy-spacing-4);
  }
}

.marketGrid:has(.soccerTeamRow) {
  grid-template-columns: minmax(320px, 3fr) repeat(3, minmax(90px, 1fr));
}

.marketLabel {
  text-align: center;
  font-size: var(--cxy-fontSize-xs);
  font-weight: var(--cxy-fontWeight-semiBold);
  padding: var(--cxy-spacing-3) var(--cxy-spacing-4);
}

.teamColumn {
  display: flex;
  align-items: center;
}

.teamContent {
  display: flex;
  align-items: center;
  gap: var(--cxy-spacing-2);
  width: 100%;
}

.teamRow {
  display: contents;

  > div {
    background-color: var(--cxy-color-container-light);
  }
}

.teamRow:last-child > div {
  border-bottom: none;
}

.teamBadge {
  inline-size: 22px;
  block-size: 22px;
  object-fit: contain;
}

.teamName {
  font-size: var(--cxy-fontSize-m);
  font-weight: var(--cxy-fontWeight-medium);
  color: var(--cxy-color-content-default);
  word-break: break-word;
  line-height: 1.2;
}

.betCell {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-width: 0;
}

.betCell button {
  width: 100%;
  max-width: none;
}

.soccerTeamRow .betCell {
  padding-inline: var(--cxy-spacing-1);
}

.soccerTeamRow .betCell button {
  font-size: var(--cxy-fontSize-s);
}

.soccerBetButton {
  min-width: 75px !important;
}

.noBet {
  font-size: var(--cxy-fontSize-m);
  color: var(--cxy-color-text-subtle);
}

.soccerTeamRow {
  display: contents;
}

.soccerTeamRow > div {
  background-color: var(--cxy-color-container-light);
}

.soccerStackedTeams {
  display: flex;
  flex-direction: column;
  gap: var(--cxy-spacing-2);
  width: 100%;
}

.soccerStackedTeam {
  display: flex;
  align-items: center;
  gap: var(--cxy-spacing-2);
  min-width: 0;
  width: 100%;
  flex: 1;
}

.matchupFooter {
  background-color: var(--cxy-color-container-subtle);
  padding: var(--cxy-spacing-3) var(--cxy-spacing-4);
  text-align: right;
  border-top: 1px solid var(--cxy-color-container);
}

.matchupAnalysisLink {
  color: var(--cxy-color-text-primary);
  text-decoration: none;
  font-size: var(--cxy-fontSize-s);
  font-weight: var(--cxy-fontWeight-semiBold);
  display: inline-flex;
  align-items: center;
  gap: var(--cxy-spacing-1);
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
}
.matchupAnalysisLink:hover {
  text-decoration: underline;
}

.arrow {
  font-size: var(--cxy-fontSize-m);
}

.eventTime {
  font-size: var(--cxy-fontSize-s);
  font-weight: var(--cxy-fontWeight-semiBold);
  color: var(--cxy-color-content-default);
}

.mobileHeader {
  background-color: var(--cxy-color-container-subtle);
  padding: var(--cxy-spacing-4);
}

.mobileMarketLabels {
  display: grid;
  grid-template-columns: 50px repeat(3, 1fr);
  grid-column-gap: var(--cxy-spacing-1);
  background-color: var(--cxy-color-container-light);
  padding: 0 var(--cxy-spacing-1);

  > div {
    padding-bottom: var(--cxy-spacing-1);
  }
}

.matchupCard:has(.soccerTeamRow) .mobileMarketLabels {
  grid-template-columns: 90px repeat(3, 1fr);
}

@media (max-width: 1024px) {
  .eventInfo {
    font-size: var(--cxy-fontSize-xs);
  }
  .marketLabel {
    padding: var(--cxy-spacing-2);
    font-size: 10px;
  }
  .marketGrid {
    grid-template-columns: 50px repeat(3, 1fr);
  }
  .marketGrid:has(.soccerTeamRow) {
    grid-template-columns: 90px repeat(3, 1fr);
  }
  .teamContent {
    flex-direction: column;
    gap: var(--cxy-spacing-1);
    text-align: center;
  }
  .teamBadge {
    inline-size: 20px;
    block-size: 20px;
  }
  .teamName {
    font-size: var(--cxy-fontSize-xs);
    word-break: break-word;
    line-height: 1.2;
  }
  .betCell button {
    max-width: 120px;
    min-width: 80px;
  }
  .soccerStackedTeam {
    gap: var(--cxy-spacing-1);
    padding-left: var(--cxy-spacing-2);
  }
  .soccerStackedTeam span[data-radix-avatar-root] {
    display: none;
  }
}

/* Gazzetta theme overrides */
[data-fpsm-theme='gazzetta'] {
  .matchupCard {
    border: 1px solid var(--cxy-color-container-extra);
  }
}
